var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmaps-map',{attrs:{"options":_vm.mapOptions},on:{"mousedown":function($event){$event.stopPropagation();}}},[_c('infocard-map-marker',{attrs:{"infocard":_vm.infocard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }